import React, { Component } from "react";
import { observer } from "mobx-react";
import { css } from "react-emotion";

import theme from "components/theme";

class FooterCategoryHeader extends Component {
  render() {
    const { styles } = this;
    const { categoryName = "", size = "14px", small = false } = this.props;

    return (
      <div className={styles.root(small)}>
        <div className={styles.categoryName(size)}>{categoryName}</div>
      </div>
    );
  }

  styles = {
    root: small => css`
      margin-bottom: ${small ? "8px" : "22px"};
    `,
    categoryName: size => css`
      ${theme.fonts.boldHeavy};
      font-size: ${size};
      color: ${theme.colors.grayDark};
      text-transform: uppercase;
    `,
  };
}

FooterCategoryHeader = observer(FooterCategoryHeader);

export default FooterCategoryHeader;
